import "./alert.css";
import React from "react";
import { AlertContext } from "../context/alertContext";

export const SuccessEmail = () => {
  const {successEmail , successHide} = React.useContext(AlertContext);
  console.log(successEmail);
  return (
    <div ref={successEmail} className="alertDiv">
      <div className="alert">
        <div>
          <div>
            <div>Success</div>
            <div>Thanks for contacting</div>
          </div>
          <div>
            <button onClick={successHide}>Done</button>
          </div>
        </div>
      </div>
    </div>
  );
};